/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_admin_tab_proposals = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool proposals`)
};

const es_admin_tab_proposals = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propuestas de herramientas`)
};

const de_admin_tab_proposals = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool-Vorschläge`)
};

const nl_admin_tab_proposals = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolvoorstellen`)
};

const fr_admin_tab_proposals = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propositions d'outils`)
};

const it_admin_tab_proposals = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proposte di strumenti`)
};

const pt_br2_admin_tab_proposals = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propostas de ferramentas`)
};

const pt_admin_tab_proposals = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propostas de ferramentas`)
};

const ja_admin_tab_proposals = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ツール提案`)
};

const zh_admin_tab_proposals = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工具建议`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const admin_tab_proposals = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.admin_tab_proposals(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("admin_tab_proposals", locale)
	if (locale === "en") return en_admin_tab_proposals(inputs)
	if (locale === "es") return es_admin_tab_proposals(inputs)
	if (locale === "de") return de_admin_tab_proposals(inputs)
	if (locale === "nl") return nl_admin_tab_proposals(inputs)
	if (locale === "fr") return fr_admin_tab_proposals(inputs)
	if (locale === "it") return it_admin_tab_proposals(inputs)
	if (locale === "pt-BR") return pt_br2_admin_tab_proposals(inputs)
	if (locale === "pt") return pt_admin_tab_proposals(inputs)
	if (locale === "ja") return ja_admin_tab_proposals(inputs)
	return zh_admin_tab_proposals(inputs)
};